import { render } from "./Contact.vue?vue&type=template&id=74e88f86&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=74e88f86&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-74e88f86"

export default script